import Icon from '../components/Icon.vue'

Icon.register({
  tag: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M0 252.1V48C0 21.5 21.5 0 48 0H252.1A48-48 0 0 0 286.1 14.1L497.9 225.9C516.7 244.7 516.7 275.1 497.9 293.8L293.8 497.9C275.1 516.7 244.7 516.7 225.9 497.9L14.1 286.1A48-48 0 0 0 0 252.1zM112 64C85.5 64 64 85.5 64 112S85.5 160 112 160 160 138.5 160 112 138.5 64 112 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tag.js
// module id = iQ8x
// module chunks = 144